export default {
  yes: { english: "Yes", spanish: "Sí" },
  optOutConfirmation: {
    english: "Are you sure you want to opt-out of the autohip program?",
    spanish:
      "¿Esta seguro de que quiere desuscribirse del programa de autoship?"
  },
  skipConfirmation: {
    english: "Are you sure you want to skip this order?",
    spanish:
      "¿Esta seguro de que quiere saltear este pedido?"
  },
};
